import { ForgotPasswordPage, requireGuest } from "@/features/auth";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  email: z.email().optional(),
});

export const Route = createFileRoute("/(auth)/forgot-password")({
  validateSearch: searchSchema,
  beforeLoad: requireGuest,
  component: ForgotPasswordPage,
});
